/* ---- UUID card (settings page) ---- */

import { ICONS } from '../icons';
import { escapeHtml } from '../utils/html';

export function renderUuidCard(uuid: string): HTMLElement {
  const el = document.createElement('div');
  el.className = 'cd';

  el.innerHTML = `
    <div class="ct">デバイスUUID</div>
    <div class="ub">
      <code>${escapeHtml(uuid)}</code>
      <button id="uuid-copy-btn">${ICONS.copy}</button>
    </div>
    <div id="uuid-copied-msg" class="cm" style="display:none">コピーしました</div>
    <div class="un">アプリ初回起動時に自動発行されたUUIDです。ジオフェンス管理サーバーに登録済みです。</div>
  `;

  const copyBtn = el.querySelector('#uuid-copy-btn')!;
  const copiedMsg = el.querySelector('#uuid-copied-msg') as HTMLElement;

  copyBtn.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(uuid);
    } catch {
      // Fallback for WebView
      const ta = document.createElement('textarea');
      ta.value = uuid;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    copyBtn.innerHTML = ICONS.check;
    copiedMsg.style.display = '';
    setTimeout(() => {
      copyBtn.innerHTML = ICONS.copy;
      copiedMsg.style.display = 'none';
    }, 1500);
  });

  return el;
}
